import { Component } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/organisms/modules/Breakdown.css'
import { MoneyflowBreakdownItem as MoneyflowBreakdownItemType, MoneyflowType, MoneyflowTracker } from 'interfaces/moneyflow'
import { Category, CategoryId } from 'interfaces/meta'
import { Timeframe } from 'interfaces/chart'
import TextButton from 'components/atoms/buttons/TextButton'
import BreakdownChart from 'components/atoms/charts/BreakdownChart'
import { getTrackerCategoryName } from 'helpers/categoriesHelpers'
import { ALL_CATEGORY_ID } from 'constants/meta'
import { MONEYFLOW_LIMIT_TYPE } from 'constants/moneyflow'
import * as isNumber from 'lodash/isNumber'
import { isTimeframeHistorical } from 'helpers/moneyflowHelpers'
import SvgIcon from 'components/atoms/SvgIcon'

type MoneyflowBreakdownItemProps = {
  memberItem: MoneyflowBreakdownItemType
  peerItem: MoneyflowBreakdownItemType
  otherItem: MoneyflowBreakdownItemType
  tracker?: MoneyflowTracker

  type: MoneyflowType
  category: Category

  maxValue: number
  monthsCount: number

  withComparison: boolean

  // for tracker creator
  timeframe: Timeframe
  setExpandedCategory: (categoryId: CategoryId | null) => void
  focusLimitField: () => void
}

export class MoneyflowBreakdownItem extends Component<MoneyflowBreakdownItemProps> {
  private get shouldHaveProjections () {
    return !isTimeframeHistorical(this.props.timeframe)
  }

  render () {
    const {
      memberItem, peerItem, otherItem, tracker,
      category, type,
      maxValue, monthsCount,
      withComparison,
    } = this.props

    const categoryId = category.id
    const categoryName = getTrackerCategoryName(category, type)

    let iconKind = categoryId
    if (categoryId === ALL_CATEGORY_ID) {
      iconKind = type === 'spending' ? 'spending' : 'income'
    }

    const iconSource = require(`icons/${ iconKind }.svg`).default
    const ctaCaption = Boolean(tracker) ? 'Edit' : 'Track'

    return (
      <li>
        <div
          className={ styles.breakdownWrapper }
        >
          <div
            className={ cn(styles.breakdown, {
              [styles.withProjections]: isNumber(memberItem.projected) && this.shouldHaveProjections,
            }) }
          >
            <div className={ styles.nameWrapper }>
              <i className={ styles.icon }>
                <SvgIcon src={ iconSource } />
              </i>
              <span className={ styles.name }>{ categoryName }</span>
            </div>
            <BreakdownChart
              memberValue={ memberItem.amount }
              peerValue={ peerItem.amount }
              otherValue={ otherItem.amount }
              memberProjected={ this.shouldHaveProjections ? memberItem.projected : undefined }
              peerProjected={ this.shouldHaveProjections ? peerItem.projected : undefined }
              otherProjected={ this.shouldHaveProjections ? otherItem.projected : undefined }
              maxTotal={ maxValue }
              limit={ tracker ? tracker.limit * monthsCount : undefined }
              limitLabel={ MONEYFLOW_LIMIT_TYPE[type] }
              withComparison={ withComparison }
            />
            <div className={ styles.ctaWrapper }>
              <TextButton size='regular' onClick={ this.onClick }>
                { ctaCaption }
              </TextButton>
            </div>
          </div>
        </div>
      </li>
    )
  }

  private onClick = () => {
    const { setExpandedCategory, category } = this.props
    setExpandedCategory(category.id)
  }
}

export default MoneyflowBreakdownItem
